<template>
  <div class="form-container">
    <template v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </template>
    <template v-else-if="hasData">
      <div class="breadcrumb">
        <span v-if="hasGoBackSlot" class="link-alike" @click="$emit('goBack')">&larr; <slot name="goback"/></span>
      </div>
      <div class="heading">
        <div class="main-info">
          <slot name="heading"/>
          <slot name="dates"/>
        </div>
        <div class="captions">
          <span v-if="deleted" class="caption-strict">Редактирование запрещено для удаленных записей.</span>
          <slot name="captions"/>
        </div>
      </div>
        <slot name="content"/>
        <div class="actions">
          <slot name="actions"/>
        </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'form-container',

  props: {
    loading: Boolean,
    hasData: Boolean,
    deleted: Boolean,
    manual: Boolean,
  },

  computed: {
    hasGoBackSlot() {
      return !!this.$slots['goback'] || !!this.$scopedSlots['goback'];
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  flex: 1;
  position: relative;
  min-height: 100%;
  padding-bottom: 20px;

  .breadcrumb {
    font-size: 12px;

    .link-alike {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .heading {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .main-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 10px;

      span {
        font-size: 12px;
        margin-left: 10px;
      }
    }

    .captions {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 4px;
      font-size: 12px;
      font-weight: bold;

      > * {
        display: inline-block;
        margin-bottom: 10px;
      }

      .caption-warn {
        background: #ff9933;
        color: white;
        padding: 6px;
      }

      .caption-strict {
        background: var(--sport-red-color);
        color: white;
        padding: 6px;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;

    button {
      white-space: nowrap;
    }
  }
}
</style>
